import { Bar, BarChart, Cell, ResponsiveContainer } from 'recharts';
import { KeyWordFilterKey } from '~/core/features/filtering/types/keywordFilter.type';

interface SliderHistogramProps {
    relativeSliderValues: [number, number];
    histogramData?: KeyWordFilterKey[];
}

export const SliderHistogram: React.FC<SliderHistogramProps> = ({ relativeSliderValues, histogramData}) => {
    if (!histogramData) {
        return null;
    }

    // calculated slider thumb values as array indices of relativeSliderValues
    const leftSliderIndex = (relativeSliderValues[0] * histogramData.length) / 100;
    const rightSliderIndex = (relativeSliderValues[1] * histogramData.length) / 100;
    return (
        <div>
            <ResponsiveContainer width="100%" height={50}>
                <BarChart data={histogramData}>
                    <Bar dataKey="doc_count" fill="var(--histogram-primary-color)">
                        {histogramData.map((entry, index) => {
                            const isInsideSelectedRange = leftSliderIndex <= index + 1 && rightSliderIndex >= index;

                            return (
                                <Cell
                                    cursor="pointer"
                                    opacity={
                                        isInsideSelectedRange
                                            ? 1
                                            : 0.5
                                    }
                                    key={`cell-${index}`}
                                />
                            );
                        })}
                    </Bar>
                </BarChart>
            </ResponsiveContainer>
        </div>
    );
};
